import { DeepChatHistoryStorageManager } from "./DeepChatHistoryStorageManager";

export class PlannerChatHistoryStorageManager extends DeepChatHistoryStorageManager {
  constructor() {
    super({
      storageKey: "planner_chat_history_v1",
      maxSessions: 50,
    });
  }

  createSession(initialTitle = "New planner chat") {
    return super.createSession(initialTitle);
  }
}
